import { render } from "./AutoApprove.vue?vue&type=template&id=7aad228b"
import script from "./AutoApprove.vue?vue&type=script&lang=js"
export * from "./AutoApprove.vue?vue&type=script&lang=js"

import "./AutoApprove.vue?vue&type=style&index=0&id=7aad228b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__